import About from './../../apps/components/About';

export default {
  path: '/quienes-somos',
  exact: 'true',
  component: About,
};